


document.addEventListener("DOMContentLoaded", function () {
  const menuItems = document.querySelectorAll("[data-menu]");
  const childShowContainer = document.querySelector("[data-child-show]");

  menuItems.forEach(menu => {
    menu.addEventListener("click", function () {
      const menuId = menu.getAttribute("data-menu");
      const childMenu = document.querySelector(`[data-child-menu="${menuId}"]`);

      if (childMenu) {
        childShowContainer.innerHTML = childMenu.innerHTML;
      }
    });
  });
});


document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll(".submenu-category-tabs li");
  const panels = document.querySelectorAll(".submenu-panel");

  tabs.forEach((tab) => {
    tab.addEventListener("click", () => {
      const name = tab.getAttribute("data-tab");

      tabs.forEach((t) => t.classList.remove("active"));
      tab.classList.add("active");

      panels.forEach((panel) => {
        panel.classList.remove("active");
        if (panel.getAttribute("data-tab-content") === name) {
          panel.classList.add("active");
        }
      });
    });
  });
});




// Select all buttons, dropdown menus, and the full header
document.addEventListener('DOMContentLoaded', () => {
  const hoverButtons = document.querySelectorAll('[data-btn-hover]');
  const dropdownMenus = document.querySelectorAll('[data-expand-hover]');
  const fullHeader = document.querySelector('[data-header-nav]');
  const toggledButtons = new Map();
  if (hoverButtons.length && dropdownMenus.length && fullHeader) {
    const hideAllDropdowns = () => {
      dropdownMenus.forEach((menu) => {
        menu.style.display = 'none';
      });
    };
    hoverButtons.forEach((button, index) => {
      const dropdownMenu = dropdownMenus[index];
      if (dropdownMenu) {
        toggledButtons.set(button, false);
        const showDropdown = () => {
          if (!toggledButtons.get(button)) {
            hideAllDropdowns();
            dropdownMenu.style.display = 'block';
          }
        };
        const hideDropdown = () => {
          if (!fullHeader.matches(':hover') && !toggledButtons.get(button)) {
            dropdownMenu.style.display = 'none';
          }
        };
        const toggleDropdown = () => {
          const isToggled = toggledButtons.get(button);
          toggledButtons.set(button, !isToggled);
          if (!isToggled) {
            hideAllDropdowns();
            dropdownMenu.style.display = 'block';
          } else {
            dropdownMenu.style.display = 'none';
          }
        };
        const resetToggleState = () => {
          toggledButtons.forEach((_, key) => {
            toggledButtons.set(key, false);
          });
        };
        button.addEventListener('mouseenter', () => {
          if (!toggledButtons.get(button)) {
            resetToggleState();
            showDropdown();
          }
        });
        button.addEventListener('mouseleave', hideDropdown);
        dropdownMenu.addEventListener('mouseenter', showDropdown);
        dropdownMenu.addEventListener('mouseleave', hideDropdown);
        button.addEventListener('click', () => {
          resetToggleState();
          toggleDropdown();
        });
        fullHeader.addEventListener('mouseleave', () => {
          if (![...toggledButtons.values()].some((state) => state)) {
            hideAllDropdowns();
          }
        });
      } else {
        console.warn(`No matching dropdown menu found for button at index ${index}.`);
      }
    });
  } else {
    console.warn('No buttons, dropdown menus, or full header found.');
  }
});

// header global dropdown script

document.addEventListener('DOMContentLoaded', function() {
  const storeToggles = document.querySelectorAll('[data-store-toggle]');
  const storeToggleContents = document.querySelectorAll('[data-store-toggle-content]');
  const storeToggleCloses = document.querySelectorAll('[data-store-toggle-close]');
  const storeToggleConfirms = document.querySelectorAll('[data-store-toggle-confirm]');
  storeToggles.forEach(toggle => {
    toggle.addEventListener('click', function() {
      const targetContent = document.querySelector(toggle.getAttribute('data-store-target'));
      if (targetContent) {
        targetContent.classList.toggle('is-open');
      }
    });
  });
  storeToggleCloses.forEach(close => {
    close.addEventListener('click', function() {
      const targetContent = document.querySelector(close.getAttribute('data-store-target'));
      if (targetContent) {
        targetContent.classList.remove('is-open');
      }
    });
  });
  storeToggleConfirms.forEach(confirm => {
    confirm.addEventListener('click', function() {
      const targetContent = document.querySelector(confirm.getAttribute('data-store-target'));
      if (targetContent) {
        targetContent.classList.remove('is-open');
      }
    });
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const containers = document.querySelectorAll('[data-selector-container]');
  containers.forEach(container => {
    const storeSelector = container.querySelector('[data-store-toggle-content-inner-select]');
    const confirmButton = container.querySelector('[data-store-toggle-confirm]');
    if (storeSelector && confirmButton) {
      confirmButton.addEventListener('click', function () {
        const selectedValue = storeSelector.value;
        if (selectedValue === '1') {
          window.location.href = 'https://borntostandout.com/';
        } else if (selectedValue === '2') {
          window.location.href = 'https://borntostandout.kr/';
        }
      });
    }
  });
});